module.exports = __webpack_public_path__ + "img/voucher-s@3x.eb36aa7.png";